module.exports = __webpack_public_path__ + "img/align-center.be30412a.svg";